const limitWindowMs = 12 * 60 * 60 * 1000

export const normalizeProfileForState = (profile, nowMs = Date.now()) => {
    if (!profile || typeof profile !== 'object') {
        throw new TypeError('Profile response is invalid')
    }

    const limitationCount = Number.isFinite(profile.limitationCount)
        ? profile.limitationCount
        : 15
    const limitationTime = Number.isFinite(profile.limitationTime)
        ? profile.limitationTime
        : null
    const limitExpired =
        limitationTime !== null && nowMs > limitationTime + limitWindowMs

    return {
        ...profile,
        acceptedMoments: arrayOrEmpty(profile.acceptedMoments),
        wantedMoments: arrayOrEmpty(profile.wantedMoments),
        rejectedMoments: arrayOrEmpty(profile.rejectedMoments),
        pinnedMoments: arrayOrEmpty(profile.pinnedMoments),
        friends: arrayOrEmpty(profile.friends),
        admin: Boolean(profile.admin ?? profile.isAdmin),
        isPremium: Boolean(profile.isPremium),
        limitationCount: limitExpired ? 15 : limitationCount,
        limitationTime: limitExpired ? nowMs : limitationTime,
    }
}

const arrayOrEmpty = (value) => (Array.isArray(value) ? value : [])
